var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CelmodeToggleButton',{attrs:{"label":_vm.name,"value":_vm.value},on:{"input":function($event){_vm.value = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }